import { render, staticRenderFns } from "./SendTextMessage.vue?vue&type=template&id=39e88d66&"
import script from "./SendTextMessage.vue?vue&type=script&lang=js&"
export * from "./SendTextMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports